var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvantage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_7_1",
    "data-name": "Component 7 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_902",
    "data-name": "Ellipse 902",
    fill: "#fff",
    stroke: "#ff4f01",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 74,
    r: 74,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 74,
    r: 72.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "agreement",
    transform: "translate(41 41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215671",
    "data-name": "Path 215671",
    d: "M20,26.361h3.585l.921-.463a5.477,5.477,0,0,1,1.1-.407V23H20Z",
    transform: "translate(2.166 2.527)",
    fill: "#ff4f01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215672",
    "data-name": "Path 215672",
    d: "M30.6,53.271a1.648,1.648,0,0,0-1.031-.36,1.7,1.7,0,0,0-1.33.641l-1.854,2.336a1.684,1.684,0,0,0,2.65,2.078l1.844-2.337a1.681,1.681,0,0,0-.279-2.358Z",
    transform: "translate(2.891 6.127)",
    fill: "#ff4f01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215673",
    "data-name": "Path 215673",
    d: "M25.357,12.047l4.667-2.8a1.12,1.12,0,0,1,1.154,0l4.667,2.8a.239.239,0,0,0,.357-.2V2H25v9.844a.236.236,0,0,0,.357.2Z",
    transform: "translate(2.768 0)",
    fill: "#ff4f01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215674",
    "data-name": "Path 215674",
    d: "M18.241,2A2.241,2.241,0,0,0,16,4.241V31.129a2.221,2.221,0,0,0,.307,1.12h.813a1.07,1.07,0,0,0,.482-.112l2.225-1.12a2.241,2.241,0,0,1-1.586-2.129V25.527a2.241,2.241,0,0,1,2.241-2.241h5.6a2.241,2.241,0,0,1,2.241,2.241v2.3a6.265,6.265,0,0,1,2.465.763,6.2,6.2,0,0,1,3.07-.82,6.05,6.05,0,0,1,2.766.663l7.361,3.7a1.077,1.077,0,0,0,.494.112h2.584a2.22,2.22,0,0,0,.307-1.111V4.241A2.241,2.241,0,0,0,45.129,2h-5.6v9.844a2.477,2.477,0,0,1-3.752,2.129l-4.09-2.459-4.09,2.455a2.477,2.477,0,0,1-3.752-2.124V2Z",
    transform: "translate(1.685 0)",
    fill: "#ff4f01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215675",
    "data-name": "Path 215675",
    d: "M7,43.847a25.886,25.886,0,0,1,7.777,2.017l1.5-1.893a3.944,3.944,0,0,1,5.517-.643,3.9,3.9,0,0,1,1.321,2,3.969,3.969,0,0,1,.884-.217,3.921,3.921,0,0,1,4.346,3.444,4,4,0,0,1-.008.9,3.874,3.874,0,0,1,2.241.822A3.932,3.932,0,0,1,32.03,53.8a3.857,3.857,0,0,1,2.261.831,3.921,3.921,0,0,1,1.13,4.67c1.337,1.145,2.121,1.869,2.159,1.9A1.712,1.712,0,0,0,40,61.235a1.681,1.681,0,0,0,0-2.376,1.121,1.121,0,0,1,1.584-1.585,1.675,1.675,0,0,0,2.371-2.366,1.12,1.12,0,1,1,1.575-1.593,1.7,1.7,0,0,0,2.391,0,1.681,1.681,0,0,0,0-2.377A1.12,1.12,0,1,1,49.5,49.353a1.686,1.686,0,0,0,2.382,0,1.793,1.793,0,0,0,.512-1.3,1.408,1.408,0,0,0-.462-1.021C48,43.562,35.211,34.113,35.083,34.017L29.441,39.3a3.978,3.978,0,0,1-5.74-5.5l6.274-6.61a3.921,3.921,0,0,0-2.887.224L19.7,31.128a3.286,3.286,0,0,1-1.5.352H7Z",
    transform: "translate(0.602 3.01)",
    fill: "#ff4f01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215676",
    "data-name": "Path 215676",
    d: "M19.526,43.181a1.673,1.673,0,0,0-1.04-.36,1.7,1.7,0,0,0-1.33.64l-2.541,3.212a1.683,1.683,0,0,0,2.637,2.092l2.55-3.222a1.691,1.691,0,0,0-.277-2.362Z",
    transform: "translate(1.474 4.913)",
    fill: "#ff4f01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215677",
    "data-name": "Path 215677",
    d: "M2,29H5.361V45.805H2Z",
    transform: "translate(0 3.249)",
    fill: "#ff4f01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215678",
    "data-name": "Path 215678",
    d: "M27.366,49.379a1.666,1.666,0,0,0-1.033-.356,1.687,1.687,0,0,0-1.31.622l-2.569,3.24A1.683,1.683,0,1,0,25.1,54.97l2.548-3.229a1.681,1.681,0,0,0-.279-2.362Z",
    transform: "translate(2.418 5.659)",
    fill: "#ff4f01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215679",
    "data-name": "Path 215679",
    d: "M24.141,45.5a1.7,1.7,0,0,0-2.359.273l-3.242,4.1a1.649,1.649,0,0,0-.351,1.232,1.681,1.681,0,0,0,2.985.85l3.249-4.1a1.691,1.691,0,0,0-.281-2.357Z",
    transform: "translate(1.947 5.193)",
    fill: "#ff4f01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215680",
    "data-name": "Path 215680",
    d: "M56.609,43.834V31.479H43.635a3.294,3.294,0,0,1-1.512-.361l-7.36-3.7a4.011,4.011,0,0,0-4.6.8l-6.742,7.1a1.781,1.781,0,0,0,.27,2.531,1.739,1.739,0,0,0,2.265-.158l5.7-5.3a2.241,2.241,0,0,1,2.812-.193c.524.387,12.026,8.889,16.486,12.694a20.13,20.13,0,0,1,5.653-1.065Z",
    transform: "translate(2.529 3.012)",
    fill: "#ff4f01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215681",
    "data-name": "Path 215681",
    d: "M55,29h3.361V45.805H55Z",
    transform: "translate(6.378 3.249)",
    fill: "#ff4f01"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantage3);
export default __webpack_public_path__ + "static/media/advantage3.83a33291358ead9d58a475bdcdc6e1d0.svg";
export { ForwardRef as ReactComponent };